import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getOrderGeneratorsFieldsWorksQualityControls(companyId, generatorId) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS].getOrderGeneratorsFieldsWorksQualityControls,
		{
			urlParams: {
				companyId,
        generatorId,
			},
		}
	)
}

function getOrderGeneratorsFieldsWorksQualityControl(companyId, generatorId, qualityControlId) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS].getOrderGeneratorsFieldsWorksQualityControl,
		{
			urlParams: {
				companyId,
        generatorId,
				qualityControlId,
			},
		}
	)
}

function createOrderGeneratorsFieldsWorksQualityControl(companyId, generatorId, payload) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS].createOrderGeneratorsFieldsWorksQualityControl,
		{
			urlParams: {
				companyId,
        generatorId,
			},
			...payload,
		}
	)
}


function putOrderGeneratorsFieldsWorksQualityControl(companyId, generatorId, qualityControlId, payload) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS].putOrderGeneratorsFieldsWorksQualityControl,
		{
			urlParams: {
				companyId,
        generatorId,
				qualityControlId,
			},
			...payload,
		}
	)
}

function patchOrderGeneratorsFieldsWorksQualityControl(companyId, generatorId, qualityControlId, payload) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS].patchOrderGeneratorsFieldsWorksQualityControl,
		{
			urlParams: {
				companyId,
        generatorId,
				qualityControlId,
			},
			...payload,
		}
	)
}

function deleteOrderGeneratorsFieldsWorksQualityControl(companyId, generatorId, qualityControlId) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS].deleteOrderGeneratorsFieldsWorksQualityControl,
		{
			urlParams: {
				companyId,
        generatorId,
				qualityControlId,
			},
		}
	)
}

export default {
	getOrderGeneratorsFieldsWorksQualityControls,
	getOrderGeneratorsFieldsWorksQualityControl,
	createOrderGeneratorsFieldsWorksQualityControl,
	putOrderGeneratorsFieldsWorksQualityControl,
	patchOrderGeneratorsFieldsWorksQualityControl,
	deleteOrderGeneratorsFieldsWorksQualityControl,
}

